import React from 'react'
import { default as BaseTextField } from '@material-ui/core/TextField'

export const MenuProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left"
  },
  getContentAnchorEl: null
}

const TextField = ({ SelectProps = {}, ...opts }) => {
  return (
    <BaseTextField
      variant="outlined"
      margin="normal"
      SelectProps={{
        MenuProps: MenuProps,
        ...SelectProps
      }}
      { ...opts } />
  )
}

export default TextField
